"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import {
	registerRouterRefresh,
	unregisterRouterRefresh,
} from "@/lib/client/app-router-refresh";

/** Wires Next’s router into `scheduleRouterRefresh` / `flushRouterRefresh`. */
export function RouterRefreshBridge() {
	const router = useRouter();

	useEffect(() => {
		registerRouterRefresh(() => {
			router.refresh();
		});
		return () => {
			unregisterRouterRefresh();
		};
	}, [router]);

	return null;
}
